<template>
    <div class="container-search">
        <div class="pandora-select-custom-container">
            <div class="pandora-select-custom-label">
            </div>
            <label :for="id"></label>
            <input type="search" class="select-variant-default" ref="selectElement" :id="id" v-bind="$attrs" :aria-label="id"
                :required="props.required" :placeholder="props.placeholder" v-model="searchQuery" @input="handleInput" />
            <img src="../../assets/search-normal.png" class="select-arrow-donw" alt="arrow-select" width="16"
                height="16" />
        </div>
        <div v-if="searchQuery != ''" class="pandora-search-container-results ">
            <div>
                <label class="pandora-search-titile-result">Documentos y normas</label>
                <hr>
            </div>
            <div class="pandora-search-result">                
        </div>
        <label class="pandora-search-titile-result">Aclaraciones</label>  
        <p v-if="searchQuery && filteredResults.length === 0" >No hay resultados para la busqueda...</p>        
            <ul class="pandora-contaner-result">
               <li v-for="item in filteredResults" :key="item.id" class="pandora-items-result">{{item.name}}</li>
           </ul>
        </div>
    </div>
</template>
<script setup>
import '../../assets/css/config.css';
import {data as datajson} from './data.js';
import { defineProps, ref,  computed } from 'vue'
const props = defineProps({
    placeholder: { type: String, default: "Buscar..." },
    id: { type: String },
    name: { type: String },
    required: { type: Boolean, default: false },
    data: { type: Array },
})
const searchQuery = ref('');
const data = ref(datajson);
const handleInput = () => {    
    console.log('Buscando', searchQuery.value)
}
const filteredResults = computed(() => {
    if(!searchQuery.value) return []
    return data.value.filter(item => 
        item.name.toLowerCase().includes(searchQuery.value.toLowerCase())
    )
})
</script>
<style>
.pandora-items-result {
    list-style-type: none;
}
.pandora-search-result {
    padding: 0 16px;
}
hr {
    border-color: rgb(243, 241, 241);
    margin: 15px 0;
}
.pandora-contaner-result {
    padding-inline-start: 0px;
    display: flex;
    flex-direction: column;
    gap: 16px;
}
.pandora-search-titile-result {
    color: var(--color-primary);
    font-weight: 900;
    font-size: 14px;
    text-decoration: underline;
}
.pandora-search-container-results {
    display: flex;
    flex-direction: column;
    padding: var(--padding-s);
    background-color: white;
    font-family: Rubik, sans-serif;
    border-radius: 8px;
    border: 1px solid #CDCED9;
    transform: translateY(5px);
}
input[type="search"]::-webkit-search-cancel-button {
    display: none
}
input[type="search"]::-ms-clear {
    display: none
}
input[type="search"]::-moz-search-clear {
    display: none
}
.pandora-select-custom-container {
    position: relative;
    width: 100%;
}
.select-arrow-donw {
    transform: translateX(-5px) translateY(13px);
    position: absolute;
    right: 10px;
    z-index: 1;
    cursor: pointer;
    pointer-events: auto;
    font-size: 16px;
}
.select-variant-default {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    width: 100%;
    height: 40px;
    border-radius: 8px;
    border: 1px solid #CDCED9;
    background: transparent;
    background-color: white;
    cursor: pointer;
    padding-left: 16px;
    font-family: Rubik, sans-serif;
    font-size: medium;
}
.select-variant-default,
option {
    color: #6B6C7E;
}
.select-variant-default:focus {
    outline: none;
}
.option-selected {
    color: var(--color-black);
}
.pandora-select-custom-label {
    font-family: Rubik-semibold, sans-serif;
    color: var(--color-dark);
    margin-bottom: 4px;
}
</style>